module.exports = __webpack_public_path__ + "static/media/fernandez_kolinsky_riviero.c294ba5c.jpg";